import axios from 'axios'

let redirecting = false
export function handleIpBan(response) {
  if (!response) return false
  const data = response.data || {}
  const blocked = data.error === 'IP_BANNED' || (response.headers && response.headers['x-access-blocked'] === 'IP_BANNED')
  if (!blocked) return false
  if (!redirecting) {
    redirecting = true
    window.location.replace((process.env.BASE_URL || '/') + 'blocked.html')
  }
  return true
}

export function checkIpAccess() {
  // Keep the access gate independent of authentication/encryption bootstrapping.
  return axios.get((process.env.VUE_APP_BASE_API || '') + '/system/access/status', { timeout: 10000 })
    .then(handleIpBan).catch(error => handleIpBan(error.response))
}
